import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=17ca7298&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=ts"
export * from "./TableWidget.vue?vue&type=script&lang=ts"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=17ca7298&prod&lang=scss&scoped=true"
import style1 from "./TableWidget.vue?vue&type=style&index=1&id=17ca7298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca7298",
  null
  
)

export default component.exports